export default __webpack_public_path__ + "static/shikhar-abe-0c825b6eebe7d5dd184397c18c42c757.webp";